import React from 'react'
import { useCitiesByState } from 'sharedKernel/hooks/ibge/useCitiesByState'
import {
  Label,
  SelectWrapper,
  StyledSelect,
  ErrorFeedback,
} from './styles'

export interface CitySelectorProps {
  id?: string
  label?: string
  isRequired?: boolean
  stateUf: string
  value: string
  isInvalid?: boolean
  errorMessage?: string
  onChange: (city: string) => void
  onBlur?: () => void
  disabled?: boolean
}

export const CitySelector = ({
  id = 'city',
  label = 'Cidade',
  isRequired = false,
  stateUf,
  value,
  isInvalid = false,
  errorMessage,
  onChange,
  onBlur,
  disabled = false,
}: CitySelectorProps): JSX.Element => {
  const { cities, error: fetchError } = useCitiesByState(stateUf)

  const isDisabled = disabled || !stateUf

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    onChange(e.target.value)
  }

  return (
    <div>
      <Label htmlFor={id}>
        {label}
        {isRequired && <span className="required">*</span>}
      </Label>

      <SelectWrapper>
        <StyledSelect
          id={id}
          value={value}
          $isInvalid={isInvalid}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={isDisabled}
        >
          {!stateUf && (
            <option value="">Selecione um estado primeiro</option>
          )}
          {stateUf && (
            <>
              <option value="">Selecione a cidade</option>
              {cities.map((city) => (
                <option key={city.id} value={city.nome}>
                  {city.nome}
                </option>
              ))}
            </>
          )}
        </StyledSelect>

      </SelectWrapper>

      {fetchError != null && (
        <ErrorFeedback>{fetchError}</ErrorFeedback>
      )}
      {isInvalid && errorMessage != null && errorMessage !== '' && (
        <ErrorFeedback>{errorMessage}</ErrorFeedback>
      )}
      {!isInvalid && !fetchError && (
        <div style={{ height: '20px' }} />
      )}
    </div>
  )
}
